module.exports = __webpack_public_path__ + "img/sv3on.83522fc4.svg";